import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import FieldList from 'Components/Universal/Questionnaire/Fields/FieldList';

const ExtraordinaryExpenseSectionPicker = ({
  clientResource, setExpensesCount, Expenses, ...rest
}) => {
  return pickFunction(clientResource, {
    [fr.relationships.default.name]: () => (<FieldList
      onCountUpdate={setExpensesCount}
      label="Anticipated extraordinary expenses"
      addLabel="Add an expense"
      keyPrefix="expenses"
      Of={Expenses}
      {...rest}
    />),
  });
};

export default ExtraordinaryExpenseSectionPicker;
